import AzureDevopsInfo  from "@/AzureDevopsInfo"
import { mapGetters } from "vuex";
const azureDevopsReplaceTokenDelimiter = '#AzureDevOpsReplaceToken#';


export const azureDevopsInfoMixin = {
  computed: {
    ...mapGetters(["tenantDetails"])
  },
  methods: {
    getAzureDevopsInfo(key) {      
      var property = AzureDevopsInfo[key];
      if(!property || property.value.includes(azureDevopsReplaceTokenDelimiter)){
        return null;
      }
      return property.value;
    },
    getAzureDevopsBuildNumber(){
      if(location.hostname.includes("localhost")){
        return "LocalHost__NoAzureBuild";
      }
      return this.getAzureDevopsInfo("BuildNumber");
    },
    getApiAzureDevopsBuildNumber(){
      if(location.hostname.includes("localhost")){
        return "LocalHost__NoAzureBuild";
      }
      if(!this.tenantDetails.AzureDevopsBuildNumber || this.tenantDetails.AzureDevopsBuildNumber.includes(azureDevopsReplaceTokenDelimiter)){
        return null
      }
      return this.tenantDetails.AzureDevopsBuildNumber;
    }
  }
}